module.exports = function(input) {
  return input[0]
}
